var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { componentTypes } from "../Form/form-constants";
import i18n from "i18next";
import get from "lodash/get";
import { INLINE_FIELDS } from "../../classConstants";
var VALIDATION_ERRORS = [];
var BookingFormSchema = /** @class */ (function () {
    function BookingFormSchema(formName, buttons, options) {
        if (buttons === void 0) { buttons = []; }
        if (options === void 0) { options = {}; }
        this.formName = formName;
        this.buttons = buttons;
        this.options = options;
    }
    BookingFormSchema.prototype.getCourseMeta = function (_a) {
        var _b = _a.showDescription, showDescription = _b === void 0 ? true : _b, _c = _a.className, className = _c === void 0 ? "" : _c, show = _a.show;
        return get(this.options, "showCourseMeta", true) && show !== false ? {
            className: className,
            "component": componentTypes.COURSE_META,
            paginated: true,
            "formName": this.formName,
            "name": this.formName + "course-meta",
            defaultTitle: "bookcart.title",
            showDescription: showDescription
        } : null;
    };
    BookingFormSchema.prototype.getPriceBreakup = function () {
        return get(this.options, "showPriceBreakup", false) ? {
            "component": componentTypes.PRICE_BREAKUP,
            "formName": this.formName,
            "name": this.formName + "-price-breakup"
        } : null;
    };
    BookingFormSchema.prototype.getButtons = function () {
        return this.buttons.length ? {
            name: "form-buttons",
            component: componentTypes.FORM_BUTTONS,
            context: "wizard",
            buttons: this.buttons
        } : null;
    };
    BookingFormSchema.prototype.getEventFormSchema = function (formWizard, otherProps) {
        if (otherProps === void 0) { otherProps = {}; }
        return {
            name: this.formName,
            schema: __assign({ children: get(this.options, "children"), "name": "select-event", "fields": [{
                        "name": "select-event",
                        component: componentTypes.BASIC,
                        className: get(this.options, "isAdminIntegration", false) ? INLINE_FIELDS : "",
                        as: get(this.options, "isAdminIntegration", false) ? "div" : "",
                        fields: __spreadArray(__spreadArray([
                            this.getCourseMeta({ showDescription: true, className: "ws-event-step-course-meta", show: true }) || null
                        ], (get(formWizard, "eventForm", []))), [
                            this.getPriceBreakup(),
                            this.getButtons(),
                        ]).filter(Boolean)
                    }] }, otherProps)
        };
    };
    BookingFormSchema.prototype.getTopFormSteps = function (formWizard) {
        var _this = this;
        var _a;
        return ((_a = formWizard.otherSteps) === null || _a === void 0 ? void 0 : _a.filter(function (_a) {
            var hideStep = _a.hideStep;
            return !hideStep;
        }).map(function (step, i, self) {
            var _a;
            return (__assign(__assign({}, step), { fields: __spreadArray(__spreadArray([_this.getCourseMeta({ showDescription: false, className: "ws-" + step.name + "-course-meta", show: get(_this.options, "showAsWizard", true) })], step.fields), [_this.getPriceBreakup()]).filter(Boolean), nextStep: step.nextStep || ((_a = self[i + 1]) === null || _a === void 0 ? void 0 : _a.name) }));
        })) || [];
    };
    BookingFormSchema.prototype.getWizSchema = function (formWizard, wizProps, validationErrors) {
        if (validationErrors === void 0) { validationErrors = VALIDATION_ERRORS; }
        var otherSteps = this.getTopFormSteps(formWizard);
        var eventForm = !get(this.options, "showEventForm", true)
            ? null
            : this.getEventFormSchema(formWizard, {
                "title": i18n.t("bookcart.event_selection"),
                "nextStep": otherSteps[0] && otherSteps[0].name,
                validationErrors: validationErrors
            }).schema;
        return {
            name: this.formName,
            schema: {
                "fields": [
                    get(formWizard, "beforeWizard", null),
                    __assign({ "component": componentTypes.WIZARD, "name": "booking-form-wiz", "fields": __spreadArray([,
                            eventForm], otherSteps).filter(Boolean) }, wizProps),
                    get(formWizard, "afterWizard", null),
                ].filter(Boolean),
                validationErrors: validationErrors
            }
        };
    };
    return BookingFormSchema;
}());
export { BookingFormSchema };
export var useBookingFormSchema = function (formName, buttons, options) {
    if (buttons === void 0) { buttons = []; }
    if (options === void 0) { options = {}; }
    return new BookingFormSchema(formName, buttons, options);
};
